import type { ComponentProps } from 'react'

import { Label as LabelPrimitive } from 'radix-ui'
import { cn } from '@/lib/utils'

function Label({ className, ...props }: ComponentProps<typeof LabelPrimitive.Root>) {
    return (
        <LabelPrimitive.Root
            data-slot='label'
            className={cn('caption-style select-none text-soft', className)}
            {...props}
        />
    )
}

export { Label }
